import src from "IMAGE";
export default { src, width: 254, height: 152, blurWidth: 0, blurHeight: 0};
